import { StatusCode } from "@/components/ui/status-code";
import { getAppName, getHttpStatusCode } from "@/utils/trace-utils";
import type { NestedDockmasterSpan } from "../../../../../../../schemas";

interface GenericDetailsSectionProps {
  span: NestedDockmasterSpan;
}

export function GenericDetailsSection({ span }: GenericDetailsSectionProps) {
  const httpStatus = getHttpStatusCode(span);
  const appName = getAppName(span);
  const httpMethod = span.attributes?.["http.method"];
  const httpUrl = span.attributes?.["http.url"];

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-xs">
        {httpMethod && (
          <div>
            <span className="text-muted-foreground">Method:</span>
            <div className="font-mono text-foreground">{httpMethod}</div>
          </div>
        )}
        <div>
          <span className="text-muted-foreground">HTTP Status:</span>
          <div className="font-mono font-medium">
            {httpStatus ? (
              <StatusCode statusCode={httpStatus} />
            ) : (
              <span className="text-muted-foreground">-</span>
            )}
          </div>
        </div>
        {appName && (
          <div>
            <span className="text-muted-foreground">App:</span>
            <div className="font-mono text-foreground">{appName}</div>
          </div>
        )}
      </div>

      {httpUrl && (
        <div className="text-xs">
          <span className="text-muted-foreground">URL:</span>
          <div className="font-mono text-foreground break-all">{httpUrl}</div>
        </div>
      )}
    </div>
  );
}
